export default {
  color: '#1976D2',
  failedColor: '#B71C1C',
  thickness: '2px',
};
